import React from 'react';
import { useTranslation } from 'react-i18next';
import ListPageHeader from '@shared/ListPageHeader';
import ThirdPartyApiLogList from '@shared/third_party_api_logs/ThirdPartyApiLogList';
import { thirdPartyApiLogService } from '@services/operator/thirdPartyApiLogService';
import { ecAccountService } from '@services/operator/ecAccountService';
import { shippingAccountService } from '@services/operator/shippingAccountService';

export default function OperatorThirdPartyApiLogsList() {
  const { t } = useTranslation();

  return (
    <div>
      <ListPageHeader items={['integration_logs', 'integration_logs.api_logs']} />
      <ThirdPartyApiLogList
        role="operator"
        service={thirdPartyApiLogService}
        ecAccountService={ecAccountService}
        shippingAccountService={shippingAccountService}
      />
    </div>
  );
}
